module.exports = __webpack_public_path__ + "img/extension.757a3c8b.svg";